import { render, staticRenderFns } from "./postArticle.vue?vue&type=template&id=33ef51ae&scoped=true&"
import script from "./postArticle.vue?vue&type=script&lang=js&"
export * from "./postArticle.vue?vue&type=script&lang=js&"
import style0 from "./postArticle.vue?vue&type=style&index=0&id=33ef51ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ef51ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33ef51ae')) {
      api.createRecord('33ef51ae', component.options)
    } else {
      api.reload('33ef51ae', component.options)
    }
    module.hot.accept("./postArticle.vue?vue&type=template&id=33ef51ae&scoped=true&", function () {
      api.rerender('33ef51ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsBlack/social/postArticle.vue"
export default component.exports